import styled from 'styled-components';
import { colors, fonts, media } from '../../../utils';


export const Container = styled.div`
    margin: 4rem auto;
`;